// Centralized branding configuration
// Change these values to rebrand the entire site

export const BRANDING = {
  // Company Names
  companyName: "Diamond Wholesale",
  companyNameFull: "Diamond Wholesale",
  shortName: "Diamond",

  // Contact Informationn
  email: "michianawholesale707@gmail.com",
  phone: "(219)-215-5555",
  tollFree: "(855) LIKE-SWI (545-3794)",
  salesPhone: "1-630-785-6838",
  fax: "(630)-785-6845",

  // Address
  address: {
    street: "707 Pine tree drive",
    city: "Michigan city",
    state: "IN",
    zip: "46360",
    country: "United States",
    full: "707 Pine tree drive, Michigan city, IN 46360, United States"
  },

  // Secondary Address (for Contact page)
  secondaryAddress: {
    street: "1442 Norwood Ave",
    city: "Itasca",
    state: "IL",
    zip: "60143",
    country: "United States",
    full: "1442 Norwood Ave Itasca, IL 60143, United States"
  },

  // Business Hours
  hours: "09:00 - 18:00, Mon - Fri",
  supportHours: "24/7 Support Center",

  // Logo
  logo: "/images/dw-logo.jpeg",

  // Website
  website: "www.diamondwholesale.com"
};
